export default function validateStatusAffiliated({ affiliated }: { affiliated: string }) {
  const value = affiliated.toLowerCase();

  if (!["", "yes", "no"].includes(value)) {
    return [{ field: "affiliated", error: "invalid" }];
  }

  return [];
}
